<template src="@/templates/dhs/interpreterDetails.html"></template>

<script>
	import Config from "../../config/config";
	import moment from 'moment'

	export default {
		name: "interpreterDetails",
		props: ['intID', 'intName', 'jobSessionID', 'naatiNumber', 'naatiCpn', 'interpreter_id'],
		data() {
			return {
				currentDate: '',
				intDetailsViewPopUp: true,
				sessionLanguages: [],
				intAccreditations: [],
        intAccreditationsDocs: [],
				intLocations: [],
				intInductions: [],
				imageURL: ""
			}
		},
		created: function () {
			this.currentDate = moment().format('DD-MM-YYYY');
			this.urls = [
				{
					identifier: 'lang',
					url: Config.publicApiURL + 'interpreter/languages?jobSessionID=' + this.jobSessionID,
				},
				{
					identifier: 'accred',
					url: Config.publicApiURL + 'interpreter/accreditation?intID=' + this.intID + 'clientID=' + localStorage.getItem("clientID"),
				},
				{
					identifier: 'loc',
					url: Config.publicApiURL + 'interpreter/locations?intID=' + this.intID,
				},
				{
					identifier: 'ind',
					url: Config.publicApiURL + 'interpreter/inductions?intID=' + this.intID
				}
			];
			// this.imageURL = Config.publicApiURL + 'interpreter/getimage?token=' + localStorage.getItem('jwt') + '&intID=' + this.intID;
			this.imageURL = Config.publicApiURL + 'interpreter/' + this.interpreter_id + '/photo/get?token=' + localStorage.getItem('jwt');
			this.viewIntDetails();
		},
		methods: {
			viewIntDetails() {
				this.urls.forEach((item) => {
					this.$http.get(item.url, {
						headers: {"Bearer": localStorage.getItem("jwt")}
					}).then((result) => {

						switch (item.identifier) {
							case 'lang': this.sessionLanguages = result.data.data; break;
							case 'accred': {
                this.intAccreditations = result.data.data;
                this.intAccreditationsDocs = result.data.docs;
              }
              break;
							case 'loc': this.intLocations = result.data.data; break;
							case 'ind': this.intInductions = result.data.data; break;
						}

					}).catch(function (error) {
						console.log(error);
					});
				});
			}
		}

	}
</script>

<style scoped>
	.interpreterDetailsModal >>> .modal-content {
		height: inherit !important;
		max-height: 800px !important;
	}

	.interpreterDetailsModal >>> .modal-content .modal-body .container-fluid object {
		height: 50vh !important;
		max-height: 800px !important;
	}
</style>




// WEBPACK FOOTER //
// src/components/dhs/interpreterDetails.vue